import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { SnackbarProvider } from "notistack";

const container = document.getElementById('root');
const root = createRoot(container!); // The `!` is needed for TypeScript to let it know the element exists.
root.render(
    <SnackbarProvider>
        <App />
    </SnackbarProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
